var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icone",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#02005c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20,
    x1: 216.41,
    x2: 280.41,
    y1: 324,
    y2: 324
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#02005c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20,
    x1: 232.41,
    x2: 264.41,
    y1: 351.71,
    y2: 296.28
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#02005c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20,
    x1: 264.41,
    x2: 232.41,
    y1: 351.71,
    y2: 296.28
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#02005c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20,
    x1: 303.31,
    x2: 375.31,
    y1: 385.07,
    y2: 385.07
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#02005c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20,
    x1: 321.31,
    x2: 357.31,
    y1: 416.25,
    y2: 353.89
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#02005c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20,
    x1: 357.31,
    x2: 321.31,
    y1: 416.25,
    y2: 353.89
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#02005c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20,
    x1: 156.3,
    x2: 256.3,
    y1: 425.96,
    y2: 425.96
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#02005c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20,
    x1: 181.3,
    x2: 231.3,
    y1: 469.26,
    y2: 382.66
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#02005c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20,
    x1: 231.3,
    x2: 181.3,
    y1: 469.26,
    y2: 382.66
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M380.14,190.14a105.1,105.1,0,0,0-7.34-23.33,64.4,64.4,0,0,0-12.66,3.33,105.64,105.64,0,0,0-19.9-44.46A106,106,0,0,0,170,210c0,2.72.11,5.41.31,8.08a50,50,0,0,0-58.23,71.83A49.78,49.78,0,0,0,136,296H383a65,65,0,0,0,54.85-99.85,65,65,0,0,0-57.71-6Z",
    fill: "#b6c4cf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.5,150.81c-.07.19-.15.37-.22.56s-.15.36-.22.55",
    fill: "none",
    stroke: "#02005c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M447.87,234.41c1.86-33.07-22.91-63.16-55.72-67.76a65.39,65.39,0,0,0-32,3.5c-6.45-34.08-30-62.91-61.32-77.47C255,71,198,88,169.85,128.24",
    fill: "none",
    stroke: "#02005c",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M427.65,278.24a64.67,64.67,0,0,0,13.64-18.62",
    fill: "none",
    stroke: "#02005c",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M150.83,176.7a107.71,107.71,0,0,0-.53,21.39A50.48,50.48,0,0,0,91,224.22,48.32,48.32,0,0,0,91,268c3,5,6,11,11,15a83.42,83.42,0,0,0,12,8,120.9,120.9,0,0,0,18,5q129,1.5,258,0c5,0,11-3,15.92-4.16",
    fill: "none",
    stroke: "#02005c",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.c81fde44d6658f94737655c4a22b2ba3.svg";
export { ForwardRef as ReactComponent };